import React from 'react'
import type { ToastContextProps } from './types'

export const ToastContext = React.createContext<ToastContextProps>({
  canShowToast: false,
  toast: undefined,
  showToast: () => undefined,
  closeToast: () => undefined,
})
